import React from 'react';

import {HStack, Text, VStack} from "@chakra-ui/react";

import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";
import {useLanguage} from "@/contexts/languageContext";

export const PollBodySkeleton = ({props}) => {
    return <HStack gap="1vw" minH="3.5rem" color="primary.550" overflow="hidden" flex={1} {...props}>
        <VStack align="flex-start" gap={1} flex={1} overflow="hidden">
            <Skeleton>
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    { stringUtil.getRandomString(10, 25) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const PollBody = ({ element, ...props }) => {
    const { language } = useLanguage();

    return (
        <HStack gap="1vw" minH="3.5rem" color="secondary.500" overflow="hidden" {...props}>
            <VStack align="flex-start" gap={1} flex={1} overflow="hidden">
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    { element?.[`${language}Title`]}
                </Text>
            </VStack>
        </HStack>
    );
};

export default PollBody;
